import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MobileViewGuard = ({ children }: any) => {
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = navigator.userAgent;

    // Android device
    const isAndroid = /Android/i.test(userAgent);

    // iPhone/iPad
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    // Mobile browser or WebView
    const isMobile = isAndroid || isIOS;

    if (!isMobile) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  return <>{children}</>;
};

export default MobileViewGuard;